import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { createComment } from '../../redux/comments/commentActions';

const CommentBox = ({ postId, onCommentSubmit }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [comment, setComment] = useState('');
  // 2026-07-25: commentReducer.js's createComment.rejected already sets
  // this correctly -- nothing anywhere read it, so a failed comment
  // silently vanished (the optimistic entry is removed) with zero
  // explanation. See 08_MASTER_TODO.md #70.
  // Was state.comments.error, a single field shared across create/update/
  // delete/like/unlike -- a failed like or delete elsewhere on the page
  // rendered here as if this compose box itself had failed. Now reads the
  // create-specific field only.
  const commentError = useSelector((state) => state.comments?.createError);

  const handleSubmit = () => {
    const text = comment.trim();
    if (!text) return;

    // Call the callback from Posts.jsx which handles optimistic state
    if (onCommentSubmit) {
      onCommentSubmit(postId, text);
    } else {
      // Fallback if no callback provided
      dispatch(createComment({ postId, content: text }));
    }

    // Reset textarea
    setComment('');
  };

  return (
    <div className="p-4 bg-gray-800/50 rounded-xl border border-gray-700/50">
      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder={t('stockers.commentBox.placeholder')}
        className="w-full p-3 bg-gray-700/50 border border-gray-600/50 rounded-lg resize-none text-sm text-gray-200 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-transparent transition-all duration-200"
        rows={3}
      />
      {commentError && (
        <p className="mt-2 text-sm text-red-400">
          {typeof commentError === 'string' ? commentError : t('stockers.commentBox.genericError')}
        </p>
      )}
      <div className="flex justify-end mt-3">
        <button
          onClick={handleSubmit}
          disabled={!comment.trim()}
          className="px-4 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white text-sm font-medium rounded-lg hover:from-purple-700 hover:to-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-lg hover:shadow-xl"
        >
          {t('stockers.commentBox.postComment')}
        </button>
      </div>
    </div>
  );
};

export default CommentBox;